import BaseApi from '@/api/BaseApi';
import type { IProductsProductResponse, IProductsResponse } from '@/models/ProductsModel';

export default class ProductApi extends BaseApi {
    async productsList () {
        return this.get<IProductsResponse>({
            url: '/api/challenges/active',
        });
    };
    async productsDetails (uuid: string | string[]) {
        return this.get<IProductsProductResponse>({
            url: `/api/challenges/active/${uuid}`,
        });
    };
};
